<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch25"><a id="ch25a"></a><a id="page_55"></a><a href="#/Contents#rch25"><span class="underline">NORA’S NOTIONS</span></a></h3>
<p class="center1"><span><i>Writer and film director Nora Ephron (1949–2012) was the acerbic wit behind</i> When Harry Met Sally, Julie and Julia, Heartburn, <i>and many other books and movies.</i></span></p>
<p class="noindent"><span>“It’s true that men who cry are sensitive to and in touch with feelings, but the only feelings they tend to be in touch with are their own.”</span></p>
<p class="noindent1a"><span>“When your children are teenagers, it’s important to have a dog so that someone in the house is happy to see you.”</span></p>
<p class="noindent1a"><span>“I don’t think any day is worth living without thinking about what you’re going to eat next at all times.”</span></p>
<p class="noindent1a"><span>“I look as young as a person can look given how old I am.”</span></p>
<p class="noindent1a"><span>“A successful parent is one who raises a child who grows up and is able to pay for his or her own psychoanalysis.”</span></p>
<p class="noindent1a"><span>“In my sex fantasy, nobody ever loves me for my mind.”</span></p>
<p class="noindent1a"><span>“The desire to get married is a basic and primal instinct. It’s followed by another basic and primal instinct: the desire to be single again.”</span></p>
<p class="noindent1a"><span>“Never marry a man you wouldn’t want to be divorced from.”</span></p>
<p class="noindent1a"><span>“Insane people are always sure that they’re fine. It is only the sane people who are willing to admit that they’re crazy.”</span></p>
<p class="noindent1a"><span>“My mother was a good cook, but what she believed about cooking is that if you worked hard and prospered, someone else would do it for you.”</span></p>
<p class="noindent1a"><span>“Oh, how I regret not having worn a bikini the entire time I was 26. If anyone young is reading this, go put on a bikini, and don’t take it off until you’re 34.”</span></p>
<p class="noindent1a"><span>“There’s a reason why 40, 50, and 60 don’t look the way they used to, and it’s not because of feminism, or better living through exercise. It’s because of hair dye.”</span></p>
<p class="noindent1a"><span>“If pregnancy were a book they would cut out the last two chapters.”</span></p>
<p class="noindent1a"><span>“You can’t retrieve your life (unless you’re on Wikipedia, in which case you can retrieve an inaccurate version of it).”</span></p>
<div class="box">
<p class="center7"><span><b>In gangster slang, a fixed boxing match is called a “barney.”</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter025.vue?e5427888